import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=e97ed918&scoped=true&"
import script from "./Consents.vue?vue&type=script&lang=js&"
export * from "./Consents.vue?vue&type=script&lang=js&"
import style0 from "./Consents.vue?vue&type=style&index=0&id=e97ed918&lang=scss&scoped=scoped&"
import style1 from "./Consents.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ed918",
  null
  
)

export default component.exports